import { useMemo } from 'preact/hooks';

const getHexFromWindow = colorLabel => {
  return window.swatches?.[colorLabel];
};

export const useSwatches = result => {
  return useMemo(() => {
    const swatches = [];
    let hasSwatchImages = false;

    if (result?.attributes?.variant_color?.length) {
      result.attributes.variant_color.forEach(color => {
        const colorLower = color.toLowerCase();
        const hex = getHexFromWindow(colorLower);

        if (!hex) return;

        const colorHandle = colorLower.replaceAll(' ', '-');
        const productImg = result.attributes.images?.find(img => img.includes(`__${colorHandle}_1`));

        if (productImg) {
          hasSwatchImages = true;
        }

        swatches.push({
          label: color,
          hex,
          productImg,
        });
      });
    }

    return { swatches, hasSwatchImages };
  }, [result]);
};
